/*
 * Demo module for making an ajax call to a backend which makes
 * facade calls, for the purpose of tracking facade requests across ajax 
 * calls.
 */

rs.module("development/codedemosforcefacadeactivity", [],

    function () {

        var _triggerSelector;
        var _backendUrl;

        //
        // Initialize the module
        //
        function initialize(triggerSelector, backendUrl) {
            _triggerSelector = triggerSelector;
            _backendUrl = backendUrl;

            $.js(_triggerSelector).on('click', function () {
                makeFacadeCalls();
            });
        }

        //
        // Make a call to initiate some Facade activity for the purposes of testing
		// facade request correlation
        //
        function makeFacadeCalls() {

            // For DEMO only, no error handling or anything 
            $.post(_backendUrl);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);